import { render, staticRenderFns } from "./workshop-item.vue?vue&type=template&id=01e3c78a&"
import script from "./workshop-item.vue?vue&type=script&lang=js&"
export * from "./workshop-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports